import React from 'react';

function Footer() {
  return (
    <footer className="bg-black text-gray-400 text-center py-6 border-t border-gray-800">
      <p className="text-sm md:text-base tracking-wide opacity-80 hover:opacity-100 transition-opacity duration-300">
        &copy; {new Date().getFullYear()} AKLO Labs. Crafting Intelligence, Optimizing Efficiency. 
        <a href="mailto:team@aklolabs.com" className="text-blue-400 hover:underline mx-2">team@aklolabs.com</a> | 
        <a href="https://aklolabs.com" target="_blank" rel="noopener noreferrer" className="text-blue-400 hover:underline mx-2">aklolabs.com</a>
      </p>
    </footer>
  );
}

export default Footer;
